import { format } from "date-fns";

import algoliaExportCSV from "../../algolia/api/algoliaExportCSV";

const formatDate = (timestamp) => timestamp && format(new Date(timestamp * 1000), "yyyy-MM-dd");

export default function productionsExportCsv({ query, filters, sortBy }) {
	return algoliaExportCSV({
		index: sortBy || "productions",
		query,
		filters,
		columns: [
			["ID", ({ id, objectID }) => id || objectID],
			[
				"ISBN",
				({ isbn, ebookISBN, partISBN, isbns }) => {
					const all = isbns?.length > 0 ? isbns : [isbn, ebookISBN, ...(partISBN || [])].filter(Boolean);
					return all.join(", ");
				},
			],
			["Title", ({ title }) => title],
			["Series", ({ series, part }) => [series, part].filter(Boolean).join(" ")],
			["Language", ({ language }) => language],
			["Author", ({ author }) => author?.join(", ")],
			["Publisher", ({ publisherName }) => publisherName],
			["Producer", ({ producerName }) => producerName],
			["Status", ({ status }) => status],
			["Production type", ({ productionType }) => productionType],
			["Article types", ({ articles }) => articles?.join(", ")],
			["No of corrections", ({ progressBar }) => progressBar?.corrected?.progressText],
			["Tags", ({ productionTags }) => productionTags?.join(", ")],
			["Publisher manager", ({ publisherManagerNames }) => publisherManagerNames?.join(", ")],
			["Narrator", ({ readerNames }) => readerNames?.join(", ")],
			["Voices", ({ voiceNames }) => voiceNames?.join(", ")],
			["Editor", ({ editorNames }) => editorNames?.join(", ")],
			["Proofer", ({ prooferNames }) => prooferNames?.join(", ")],
			["Production manager", ({ managerNames }) => managerNames?.join(", ")],
			["Subcontractor", ({ subcontractorName }) => subcontractorName],
			[
				"Duration",
				({ duration }) => (duration?.time && duration?.isEstimated ? `${duration.time} *` : duration?.time),
			],
			["Pages", ({ pages }) => pages],
			["Done date", ({ firstDoneDate_timestamp }) => formatDate(firstDoneDate_timestamp)],
			["Created", ({ created_timestamp }) => formatDate(created_timestamp)],
			["Updated", ({ updated_timestamp }) => formatDate(updated_timestamp)],
			["Script date", ({ scriptDate }) => scriptDate?.date],
			["Production date", ({ productionDate_timestamp }) => formatDate(productionDate_timestamp)],
			["Delivery date", ({ deliveryDate_timestamp }) => formatDate(deliveryDate_timestamp)],
		],
		attributes: [
			"objectID",
			"id",
			"isbn",
			"ebookISBN",
			"partISBN",
			"isbns",
			"title",
			"series",
			"part",
			"language",
			"author",
			"publisherName",
			"producerName",
			"status",
			"productionType",
			"articles",
			"progressBar",
			"productionTags",
			"publisherManagerNames",
			"readerNames",
			"voiceNames",
			"editorNames",
			"prooferNames",
			"managerNames",
			"subcontractorName",
			"duration",
			"pages",
			"firstDoneDate_timestamp",
			"created_timestamp",
			"updated_timestamp",
			"scriptDate",
			"productionDate_timestamp",
			"deliveryDate_timestamp",
		],
	});
}
